import React, { useState } from 'react'
import SecondarySectionLayout from '../layout/SecondarySectionLayout'
import Flickity from 'react-flickity-component'
import PrimaryButton from '../common/PrimaryButton'
import VideoWrapper from '../common/VideoWrapper';
import { graphql, useStaticQuery } from 'gatsby';
import AniLink from "gatsby-plugin-transition-link/AniLink"
import ModalPopUp from '../common/ModalPopUp';

const OurStudent = () => {

    const flickityOptions = {
        cellAlign: "center",
        contain: true,
        pageDots: true,
        prevNextButtons: false,
        freeScroll: true,
        wrapAround: true,
        adaptiveHeight: true,
        draggable: true,
        initialIndex: 1,
    };

    const data = useStaticQuery(query);

    const { allStrapiHomeOurStudent: { nodes: HomeOurStudent }, allStrapiSuccessStory: { nodes: HomeSuccessStories } } = data;

    const { home_ourStudent_heading, home_ourStudent_button } = HomeOurStudent[0];

  const [showVideo, setShowVideo] = useState({
    showVideo: false,
    videoUrl: null
  });
    return (
        <>
            <SecondarySectionLayout SecondarySectionAltHeading={home_ourStudent_heading}>
                <div className="our_student_carousel_wrapper">
                    <Flickity
                        className="our_student_main_carousel"
                        elementType={"div"}
                        options={flickityOptions}
                        disableImagesLoaded={false}
                        reloadOnUpdate
                        static
                    >
                        {HomeSuccessStories.map((homeSuccessStoriesItem) => (<div className="our_student_carousel_cell" key={homeSuccessStoriesItem.id}>
                          <div className="our_student_carousel_item">
                            <VideoWrapper ThumbnailUrl={homeSuccessStoriesItem.Success_Stories_Card.video_thumbnail.url} MaxWidth={310} PlayBtnUrl={"https://s3.us-east-2.wasabisys.com/ufaber-lms/files/1f977ee24b62b3ed194afd01468d43d2.svg"} VideoUrl={homeSuccessStoriesItem.Success_Stories_Card.video_url} VideoFunction={setShowVideo} />
                                <p className="our_student_carousel_item_name">{homeSuccessStoriesItem.success_story_name}</p>
                                <p className="our_student_carousel_item_description">{homeSuccessStoriesItem?.success_story_description}</p>
                            </div>
                        </div>))}
                    </Flickity>
                </div>
                <AniLink fade to={home_ourStudent_button.button_redirection}>
                    <PrimaryButton ButtonText={home_ourStudent_button.button_text} MaxWidth={13.9375} />
                </AniLink>
        </SecondarySectionLayout>
        {showVideo.showVideo && <ModalPopUp ShowVideo={setShowVideo} VideoLink={showVideo.videoUrl } />}
        </>
    )
}

export const query = graphql`
{
    allStrapiHomeOurStudent {
    nodes {
      home_ourStudent_heading
      home_ourStudent_button {
        button_text
        button_redirection
      }
    }
  }
  allStrapiSuccessStory(filter: {published_homepage: {eq: true}}) {
    nodes {
      Success_Stories_Card {
        video_thumbnail {
          url
        }
        video_url
      }
      success_story_name
      id
    }
  }
}
`

export default OurStudent